type ApiFieldError = {
  message?: string;
  field?: string;
};

type ApiErrorBody = {
  message?: string;
  error?: string;
  errors?: ApiFieldError[];
};

/**
 * Prefer field-level validation messages from API bodies shaped like:
 * { message: "Validation failed", errors: [{ message, field }] }
 */
export function extractErrorMessage(error: unknown, fallback: string) {
  const err = error as {
    response?: { data?: ApiErrorBody };
    message?: string;
  };
  const data = err.response?.data;

  if (data && Array.isArray(data.errors) && data.errors.length > 0) {
    const messages = data.errors
      .map((item) => (typeof item?.message === "string" ? item.message.trim() : ""))
      .filter(Boolean);
    if (messages.length) return messages.join(". ");
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message.trim();
  }
  if (typeof data?.error === "string" && data.error.trim()) {
    return data.error.trim();
  }
  if (typeof err.message === "string" && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
